import { z } from "zod";

const upsertVariantSchema = z.object({
  id: z.string().optional(),
  size: z.string().trim().max(40).nullable().optional(),
  color: z.string().trim().max(40).nullable().optional(),
  sku: z.string().trim().min(1).max(60),
  priceOverride: z.number().int().nonnegative().nullable().optional(),
  stock: z.number().int().nonnegative(),
  imageUrl: z.string().url().nullable().optional()
});

export const upsertProductSchema = z.object({
  id: z.string().optional(),
  // Optional — the repository derives it from `name` when omitted and
  // always re-validates/normalizes it server-side, so this is never
  // trusted as final even when the client sends one.
  slug: z.string().trim().max(80).optional(),
  name: z.string().trim().min(1).max(200),
  description: z.string().trim().max(20000).nullable().optional(),
  shortDescription: z.string().trim().max(500).nullable().optional(),
  tags: z.array(z.string().trim().max(40)).max(30).optional(),
  basePrice: z.number().int().nonnegative(),
  compareAtPrice: z.number().int().nonnegative().nullable().optional(),
  costPriceCents: z.number().int().nonnegative().nullable().optional(),
  images: z.array(z.string().url()).max(20).optional(),
  categoryId: z.string().min(1),
  isActive: z.boolean().optional(),
  isReturnable: z.boolean().optional(),
  isNewArrival: z.boolean().optional(),
  isBestSeller: z.boolean().optional(),
  weightGrams: z.number().int().nonnegative().nullable().optional(),
  rewardCoins: z.number().int().nonnegative().optional(),
  seoKeywords: z.string().trim().max(500).nullable().optional(),
  variants: z.array(upsertVariantSchema)
});
export type UpsertProductSchemaInput = z.infer<typeof upsertProductSchema>;
